import {
	COUPON_CATEGORIES_CREATE,
	COUPON_CATEGORIES_CREATE_SUCCESS,
	COUPON_CATEGORIES_CREATE_FAIL,
	COUPON_CATEGORIES_UPDATE,
	COUPON_CATEGORIES_UPDATE_SUCCESS,
	COUPON_CATEGORIES_UPDATE_FAIL,
	COUPON_CATEGORIES_FIND_ALL_BY_PAGE_AND_OPTIONS,
	COUPON_CATEGORIES_FIND_ALL_BY_PAGE_AND_OPTIONS_SUCCESS,
	COUPON_CATEGORIES_FIND_ALL_BY_PAGE_AND_OPTIONS_FAIL,
	COUPON_CATEGORIES_GET_DETAILS,
	COUPON_CATEGORIES_GET_DETAILS_SUCCESS,
	COUPON_CATEGORIES_GET_DETAILS_FAIL,
	OPTIONS_GET,
} from 'Constants/actionTypes';

export const couponCategoriesCreate = (data) => ({
	type: COUPON_CATEGORIES_CREATE,
	payload: data,
});

export const couponCategoriesCreateSuccess = (data) => ({
	type: COUPON_CATEGORIES_CREATE_SUCCESS,
	payload: data,
});

export const couponCategoriesCreateFail = (error) => ({
	type: COUPON_CATEGORIES_CREATE_FAIL,
	payload: error,
});

export const couponCategoriesUpdate = (data) => ({
	type: COUPON_CATEGORIES_UPDATE,
	payload: data,
});

export const couponCategoriesUpdateSuccess = (data) => ({
	type: COUPON_CATEGORIES_UPDATE_SUCCESS,
	payload: data,
});

export const couponCategoriesUpdateFail = (error) => ({
	type: COUPON_CATEGORIES_UPDATE_FAIL,
	payload: error,
});

export const couponCategoriesFindAllByPageAndOptions = (params) => ({
	type: COUPON_CATEGORIES_FIND_ALL_BY_PAGE_AND_OPTIONS,
	payload: params,
});

export const couponCategoriesFindAllByPageAndOptionsSuccess = (data) => ({
	type: COUPON_CATEGORIES_FIND_ALL_BY_PAGE_AND_OPTIONS_SUCCESS,
	payload: data,
});

export const couponCategoriesFindAllByPageAndOptionsFail = (error) => ({
	type: COUPON_CATEGORIES_FIND_ALL_BY_PAGE_AND_OPTIONS_FAIL,
	payload: error,
});

export const couponCategoriesGetDetails = (category) => ({
	type: COUPON_CATEGORIES_GET_DETAILS,
	payload: category,
});

export const couponCategoriesGetDetailsSuccess = (data) => ({
	type: COUPON_CATEGORIES_GET_DETAILS_SUCCESS,
	payload: data,
});

export const couponCategoriesGetDetailsFail = (error) => ({
	type: COUPON_CATEGORIES_GET_DETAILS_FAIL,
	payload: error,
});

export const couponCategoriesGetOptions = (params) => ({
	type: OPTIONS_GET,
	payload: {
		tag: 'couponCategory',
		params,
	},
});
